export class Option {
  name: string;
  value: string;
  icon: string;
  displayValue: string;
  error: boolean;

  constructor(name: string, value: string, icon: string, displayValue?: string, error: boolean = false) {
    this.name = name;
    this.value = value;
    this.displayValue = displayValue;
    this.icon = icon;
    this.error = error;
  }
}

export class PaymentOption {
  value: string;
  display: string;
  icon: string;

  constructor(value: string, display: string, icon: string) {
    this.value = value;
    this.display = display;
    this.icon = icon;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/dropdown/dropdown-option-model.ts